// CRO-94 — Loxa protection opt-in row on the main cart page.
// Markup is rendered by snippets/loxa-cart-offer.liquid; this only hydrates it.
//
// Adding goes through `loxa:trigger:addInsuranceFromCart` because that is what
// stamps the shared _loxaLinkId onto the product line. Without the pairing the
// insurance line renders nowhere and still charges.

(function () {
  'use strict';

  var GATE_CLASS = 'cart-loxa-upsell';
  var WAIT_TIMEOUT_MS = 8000;
  var POLL_INTERVAL_MS = 50;
  var ADD_TIMEOUT_MS = 15000;

  // One cart write at a time — each ends in a full .drawer__inner redraw.
  var writing = false;
  var seen = {};

  function strings() {
    return window.loxaCartStrings || {};
  }

  function lockRows(locked) {
    writing = locked;
    document.querySelectorAll('.loxa-cart-offer__checkbox').forEach(function (input) {
      input.disabled = locked;
    });
  }

  function root() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
      .replace(/\/$/, '');
  }

  function money(value) {
    return '£' + Number(value).toFixed(2);
  }

  function fill(template, values) {
    var out = String(template || '');
    Object.keys(values).forEach(function (key) {
      out = out.split('[' + key + ']').join(values[key]);
    });
    return out;
  }

  function track(event, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, detail));
  }

  function waitForLoxa(cb) {
    if (window.LoxaShopify) { cb(window.LoxaShopify); return; }
    var start = Date.now();
    var timer = setInterval(function () {
      if (window.LoxaShopify) {
        clearInterval(timer);
        cb(window.LoxaShopify);
      } else if (Date.now() - start > WAIT_TIMEOUT_MS) {
        clearInterval(timer);
      }
    }, POLL_INTERVAL_MS);
  }

  // Core's _pickPrimaryPlan, minus _getSelectablePlans — that reads the shared
  // PDP integrationType.
  function pickPlan(quote) {
    var plans = (quote && Array.isArray(quote.insurances) ? quote.insurances : [])
      .filter(function (plan) { return plan && plan.pricing_type === 'addon'; });
    if (!plans.length) return null;
    var preferred = plans.find(function (plan) { return plan.default_selected === true; });
    if (preferred) return preferred;
    return plans.reduce(function (best, plan) {
      return parseFloat(plan.insurance_price) > parseFloat(best.insurance_price) ? plan : best;
    }, plans[0]);
  }

  function isAddonQuote(quote) {
    if (!quote || !quote.insurable || !quote.active) return false;
    return quote.integration_type === 'addon' || quote.integration_type === 'add_on';
  }

  // ---- details dialog -----------------------------------------------------

  // Body copy comes from Loxa's own builder, so the cover wording stays theirs
  // and the .loxa-sidebar-* classes it emits are already styled in loxa.css.
  function openDetails(quote) {
    var Loxa = window.LoxaShopify;
    if (!Loxa || typeof Loxa.getSidebarStructuredContent !== 'function') return;

    var content = Loxa.getSidebarStructuredContent(quote);
    if (!content) return;

    var dialog = document.getElementById('LoxaCartDetails');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'LoxaCartDetails';
      dialog.className = 'loxa-cart-details';
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target.closest('.loxa-cart-details__close')) dialog.close();
      });
      document.body.appendChild(dialog);
    }

    dialog.innerHTML =
      '<div class="loxa-cart-details__inner">' +
        '<button type="button" class="loxa-cart-details__close" aria-label="' +
          (strings().close || 'Close') + '">&times;</button>' +
        '<div class="loxa-cart-details__content">' +
          (content.introHtml || '') + (content.termsHtml || '') +
        '</div>' +
      '</div>';

    dialog.showModal();
  }

  // ---- cart refresh -------------------------------------------------------

  function cartSectionId() {
    var main = document.getElementById('MainCart');
    var wrapper = main && main.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : 'cart';
  }

  // Pulls the cart template's own section, not the `cart-drawer` one cart.js
  // uses: that renders in the static (mini-bag) location and drags the narrow
  // drawer grid onto the cart page.
  function refreshCart() {
    var sectionId = cartSectionId();
    var sections = sectionId + ',cart-icon-bubble';
    return fetch(root() + '/cart?sections=' + encodeURIComponent(sections))
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var parser = new DOMParser();

        var cartHtml = data[sectionId];
        var target = document.querySelector('#CartDrawer .drawer__inner');
        if (cartHtml && target) {
          var source = parser
            .parseFromString(cartHtml, 'text/html')
            .querySelector('.drawer__inner');
          if (source) target.innerHTML = source.innerHTML;
        }

        var bubbleHtml = data['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          var bubbleSource = parser
            .parseFromString(bubbleHtml, 'text/html')
            .querySelector('.shopify-section');
          if (bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
        }

        // Contentsquare re-reads its cart CVars off this. 'cart-items' so
        // CartItems.onCartUpdate skips refetching what is already current.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        }
      });
  }

  // ---- element ------------------------------------------------------------

  class LoxaCartOffer extends HTMLElement {
    connectedCallback() {
      if (this.hydrated) return;
      this.hydrated = true;

      this.checkbox = this.querySelector('.loxa-cart-offer__checkbox');
      this.errorEl = this.querySelector('.loxa-cart-offer__error');
      this.detailsBtn = this.querySelector('.loxa-cart-offer__details');

      this.checkbox.addEventListener('change', this.onToggle.bind(this));
      this.detailsBtn.addEventListener('click', this.onDetails.bind(this));

      this.whenArmed(this.hydrate.bind(this));
    }

    disconnectedCallback() {
      if (this.armObserver) this.armObserver.disconnect();
    }

    // WebTrends may arm the test after this script has run.
    whenArmed(callback) {
      if (document.documentElement.classList.contains(GATE_CLASS)) {
        callback();
        return;
      }
      this.armObserver = new MutationObserver(function () {
        if (document.documentElement.classList.contains(GATE_CLASS)) {
          this.armObserver.disconnect();
          callback();
        }
      }.bind(this));
      this.armObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    hydrate() {
      if (this.dataset.mode === 'insured') {
        this.trackShown('insured');
        return;
      }
      this.quoteLine().then(this.render.bind(this)).catch(function () {});
    }

    // The product title, not the line title — Loxa derives the premium from it,
    // and the variant suffix would quote differently from the PDP.
    quoteLine() {
      return new Promise(function (resolve, reject) {
        waitForLoxa(function (Loxa) {
          if (typeof Loxa._fetchCartItemInsurance !== 'function') {
            reject(new Error('Loxa cart quoting unavailable'));
            return;
          }
          Loxa._fetchCartItemInsurance(
            this.dataset.variantId,
            this.dataset.productTitle,
            parseInt(this.dataset.unitPrice, 10),
            this.dataset.productHandle
          ).then(resolve, reject);
        }.bind(this));
      }.bind(this));
    }

    render(quote) {
      if (!isAddonQuote(quote)) return;
      var plan = pickPlan(quote);
      if (!plan) return;

      this.quote = quote;
      this.plan = plan;

      var price = parseFloat(plan.insurance_price);
      var term = parseInt(plan.insurance_term || plan.term, 10);
      var quantity = parseInt(this.dataset.quantity, 10) || 1;

      this.querySelector('.loxa-cart-offer__title-text').textContent = term > 0
        ? fill(strings().offerTitle, { term: term, price: money(price) })
        : fill(strings().offerTitleNoTerm, { price: money(price) });

      this.querySelector('.loxa-cart-offer__qty-total').textContent = quantity > 1
        ? fill(strings().totalForQuantity, { total: money(price * quantity), count: quantity })
        : '';

      if (!plan.insurance_content || !plan.insurance_content.sidebar_content) {
        this.detailsBtn.hidden = true;
      }

      this.dataset.ready = '';
      this.trackShown('offered', price);
    }

    onDetails() {
      if (this.quote) {
        openDetails(this.quote);
        return;
      }
      // An insured row never quotes on load.
      this.quoteLine().then(function (quote) {
        this.quote = quote;
        openDetails(quote);
      }.bind(this)).catch(function () {});
    }

    onToggle(event) {
      // cart-drawer-items binds a delegated change listener and reads
      // event.target.dataset.index / .value as a quantity, so a tick reaches it
      // as line "undefined", quantity "on" and the theme reports a cart error.
      event.stopPropagation();

      if (writing) return;
      lockRows(true);
      this.setBusy(true);
      this.setError('');

      var checkboxId = this.checkbox.id;
      var write = this.checkbox.checked ? this.addProtection() : this.removeProtection();

      write
        .then(function () {
          return refreshCart().then(function () {
            lockRows(false);
            var replacement = document.getElementById(checkboxId);
            if (replacement) replacement.focus();
          }).catch(function (error) {
            // The cart did change; only the redraw failed.
            if (window.console) console.warn('[loxa-cart-offer] redraw failed', error);
            window.location.reload();
          });
        })
        .catch(function (error) {
          lockRows(false);
          this.setBusy(false);
          this.checkbox.checked = !this.checkbox.checked;
          this.setError(strings().error);
          if (window.console) console.warn('[loxa-cart-offer]', error);
        }.bind(this));
    }

    addProtection() {
      if (!this.plan || !this.quote) return Promise.reject(new Error('no quote'));

      return this.currentCartItem().then(function (cartItem) {
        var variantId = String(cartItem.id);
        var plan = this.plan;

        return new Promise(function (resolve, reject) {
          // Loxa repaints the cart itself on success, and its quiet path formats
          // the total with Shopify.formatMoney — which this theme sets no
          // money_format for, so it throws and a successful add reports failure.
          // We redraw from the section anyway, so take the hook's offer to skip.
          function suppressNotify(event) {
            event.preventDefault();
          }

          function stop() {
            clearTimeout(timer);
            document.removeEventListener('loxa:after:addInsuranceFromCart', onDone);
            document.removeEventListener('loxa:before:notifyCartChange', suppressNotify);
          }

          function onDone(event) {
            var detail = event.detail || {};
            if (String(detail.variantId) !== variantId) return;
            stop();
            if (!detail.success) {
              reject(detail.error || new Error('add failed'));
              return;
            }
            track('loxa_cart_offer_added', {
              loxa_variant_id: variantId,
              loxa_premium: parseFloat(plan.insurance_price),
              loxa_plan_code: plan.code
            });
            resolve();
          }

          var timer = setTimeout(function () {
            stop();
            reject(new Error('add timed out'));
          }, ADD_TIMEOUT_MS);

          document.addEventListener('loxa:after:addInsuranceFromCart', onDone);
          document.addEventListener('loxa:before:notifyCartChange', suppressNotify);
          document.dispatchEvent(new CustomEvent('loxa:trigger:addInsuranceFromCart', {
            detail: {
              plan: plan,
              cartItem: cartItem,
              insuranceData: this.quote,
              bannerEl: null
            }
          }));
        }.bind(this));
      }.bind(this));
    }

    removeProtection() {
      var key = this.dataset.insuranceKey;
      if (!key) return Promise.reject(new Error('no insurance line'));

      return fetch(root() + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart/change.js HTTP ' + response.status);
        track('loxa_cart_offer_removed', { loxa_variant_id: this.dataset.variantId });
      }.bind(this));
    }

    // A line's key changes with its properties, so read the live cart rather
    // than trusting the key this row was rendered with.
    currentCartItem() {
      return fetch(root() + '/cart.js', { headers: { 'X-Loxa-Separate-Add': '1' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var key = this.dataset.lineKey;
          var variantId = this.dataset.variantId;
          var match = items.find(function (item) { return item.key === key; });
          if (!match) {
            match = items.find(function (item) {
              return String(item.id) === variantId && !(item.properties || {})._insuredProductId;
            });
          }
          if (!match) throw new Error('cart line not found');
          return match;
        }.bind(this));
    }

    // Rows are re-rendered on every cart change, so count a line once per page.
    trackShown(state, premium) {
      var key = this.dataset.variantId + ':' + state;
      if (seen[key]) return;
      seen[key] = true;
      track('loxa_cart_offer_shown', {
        loxa_variant_id: this.dataset.variantId,
        loxa_state: state,
        loxa_premium: premium
      });
    }

    setBusy(busy) {
      this.toggleAttribute('data-busy', busy);
      this.checkbox.disabled = busy;
    }

    setError(message) {
      this.errorEl.textContent = message || '';
    }
  }

  if (!customElements.get('loxa-cart-offer')) {
    customElements.define('loxa-cart-offer', LoxaCartOffer);
  }
})();
